import { setCollectedGoodies } from '../utils/initialize';
import {
  SET_COLLECTED_GOODIES,
  SET_COLLECTED_NEW_GOODIES,
  SET_NEW_GOODY,
} from '../constants';

const initialState = setCollectedGoodies();

const collectedGoodies = (state = initialState, action) => {
  switch (action.type) {
    case SET_NEW_GOODY:
      return {
        ...state,
        list: [
          ...state.list,
          action.payload.id,
        ],
        newItems: [
          ...state.newItems,
          action.payload.id,
        ],
      };
    case SET_COLLECTED_GOODIES:
      return {
        ...state,
        list: action.payload.collectedGoodies,
      };
    case SET_COLLECTED_NEW_GOODIES:
      return {
        ...state,
        newItems: action.payload.collectedNewGoodies,
      };
    default:
      return state;
  }
};

export default collectedGoodies;



// WEBPACK FOOTER //
// ./src/reducers/collectedGoodies.js